import React from 'react';
import { Link2 } from 'lucide-react';
import { StakeConnection } from './StakeConnection';
import { DiscordConnection } from './DiscordConnection';
import { KickConnection } from './KickConnection';
import './connectedAccounts.css';

export const ConnectedAccounts = () => <section id="connected-accounts" className="settings-section connected-accounts" data-testid="connected-accounts-section" aria-labelledby="connected-accounts-heading">
  <h2 id="connected-accounts-heading" data-testid="connected-accounts-title"><Link2 size={18} aria-hidden="true" />Connected Accounts</h2>
  <div className="connections-grid" data-testid="connected-accounts-grid"><StakeConnection /><DiscordConnection /><KickConnection /></div>
</section>;